import { type FieldOption } from '../config-field-dropdown';

import { messages } from './messages';

export enum SIZE_VALUES {
	SMALL = 'small',
	LARGE = 'large',
}

export const SIZE_OPTIONS: FieldOption<SIZE_VALUES>[] = [
	{
		label: messages.sizeSmall,
		value: SIZE_VALUES.SMALL,
	},
	{
		label: messages.sizeLarge,
		value: SIZE_VALUES.LARGE,
	},
];
